<template>
<main-content>
    <kt-row>
        <kt-col lg="4">
            <kt-panel>
                <kt-panel-body>
                    موجودی {{ price }}
                </kt-panel-body>
            </kt-panel>
        </kt-col>
    </kt-row>
    <kt-row>
        <kt-col lg="4">
            <kt-panel>
                <kt-panel-body>
                    <kt-form-control v-model="inc_price"></kt-form-control>
                    <button @click="increase" class="mt-2 btn btn-primary">افزایش موجودی</button>
                </kt-panel-body>
            </kt-panel>
        </kt-col>
    </kt-row>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { dashboardService } from '@/common/api.service'

export default {
    name: 'increase',
    components: {
        'main-content': mainContent
    },
    data() {
        return {
            price: 0,
            inc_price: 1000,
        }
    },
    mounted() {
        dashboardService.fetch().then(response => {
            this.price = response.data.data.price
        })
    },
    methods: {
        increase() {
            let data = {
                amount: this.inc_price,
                // token: 'woUdAtgU1Fnjl9R97LuW',
                token: '1'
            }
            dashboardService.increase(data).then(response => {
                // window.open("http://api.paystar.ir/gateway/start-pay/"+response.data.data.auhtority, '_blank');
                window.open("http://localhost:3000/gateway/start-pay/"+response.data.data.auhtority, '_blank');
            })
        }
    }
}
</script>
